import { useShopify } from "@hooks/useShopify"
import { Box, Spinner, VStack } from "@chakra-ui/react"
import React, { memo, useCallback, useEffect, useMemo, useState } from "react"

import ProductShopTheLookProduct from "./ProductShopTheLookProduct"

type ProductShopTheLookProductsProps = {
  product: GatsbyTypes.SanityProduct
}

const ProductShopTheLookProducts: React.FC<ProductShopTheLookProductsProps> = ({ product }) => {
  const { getProducts } = useShopify()
  const [products, setProducts] = useState([])
  const productHandlesToGet = useMemo(
    () => product?.tags?.filter(tag => tag?.includes("stl:"))?.map(product => product?.split(":")?.[1]) || [],
    [product]
  )

  const getStlProducts = useCallback(async () => {
    if (productHandlesToGet?.length > 0) {
      const fetchedProducts = await getProducts({ handles: productHandlesToGet, firstImages: 10, firstVariants: 10 })
      setProducts(fetchedProducts)
    }
  }, [getProducts, productHandlesToGet])

  useEffect(() => {
    getStlProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productHandlesToGet])

  return productHandlesToGet?.length > 0 ? (
    <Box mt={4}>
      {products?.length > 0 ? (
        <VStack alignItems={`flex-start`} gap={4}>
          {products?.map(product =>
            product?.availableForSale == true ? <ProductShopTheLookProduct key={product?.id} product={product} /> : null
          )}
        </VStack>
      ) : (
        <Box py={4}>
          <Spinner />
        </Box>
      )}
    </Box>
  ) : null
}

export default memo(ProductShopTheLookProducts)
